import useTeachers from "./useTeachers"

export const useOpenTeacherContracts = () => {
  const teachers = useTeachers()

  return teachers.filter((t) => !t.hasContract || !t.hasVog)
}
